import type { LocationQuery, RouteLocationRaw } from 'vue-router'

/**
 * Builds the route for a color-sibling navigation on the PDP while keeping the
 * slug currently in the URL.
 *
 * ECOM-2207 / ECOM-1886: "fast color switching" reuses the mounted PDP only
 * while the page key stays constant, and the page key is `route.params.slug`.
 * Re-deriving the slug from each sibling's own name (slugify(name)) makes the
 * slug — and therefore the key — change whenever a sibling's name differs from
 * the slug in the current URL (a renamed product, an SEO slug, or simply a
 * color variant with a different name). That key change forces a full PDP
 * remount instead of the in-place variant swap. Preserving `currentSlug` keeps
 * the key stable so only the `id` (and optional order number) change.
 */
export const buildSiblingColorRoute = (
  currentSlug: string,
  siblingId: number,
  orderNumber?: string,
): RouteLocationRaw => {
  const query: LocationQuery = {}
  if (orderNumber) {
    query.ordernumber = orderNumber
  }

  return {
    name: 'p-slug-id',
    params: { slug: currentSlug, id: String(siblingId) },
    query,
  }
}
